export class Issue {
    id: number;    
    project_id: number;
    title: string;
    component_id: number;
    module_id: number;
    enviroment: string;
    description: string;
    version_id: number;
    target_version_id: number;
    priority_id: number;
    severity_id: number;
    assignee: number;
    related_to: number;
    cc_list: Array<any>;
    tags: Array<string>;
    attachments: any;
    status: number;
    created_by: number;
    original_estimate: string;
    current_estimate: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/models/issue.ts